<template>
    <v-tooltip
        v-bind="{...tooltipPositionProps, ...contentClassProp, ...$attrs}">
        <template #activator="{ on, attrs }">
            <slot :attrs="attrs"
                  :on="on"
                  name="activator" />
        </template>
        <slot />
    </v-tooltip>
</template>

<script>
import tooltipPositionMixin from '../../mixins/tooltipPositionMixin'

export default {
    inheritAttrs: false,
    mixins: [tooltipPositionMixin],
    computed: {
        contentClassProp() {
            return (this.$attrs['content-class'] || this.$attrs.contentClass) ? {} : { 'content-class': 'tooltip-glass tooltip-white elevation-8' }
        }
    }
}
</script>
